<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { leadSource } from '../schema'; // adjust as needed

	const dispatch = createEventDispatcher();
	let showLeadSource = true;

	let mktSource;
	onMount(() => {
		const params = new URLSearchParams(window.location.search);
		console.log('params = ', params);
		console.log("params.has('mkt_source') = ", params.has('mkt_source'));
		if (params.has('mkt_source')) {
			showLeadSource = false;
		}

		mktSource = params.get('mkt_source');
		if (mktSource) {
			console.log('mktSource = ', mktSource);

			dispatch('mktSourceFromParams', { mktSource });
		}
	});

	$: if (leadSource.value !== '') {
		mktSource = leadSource.value;
		dispatch('mktSourceFromField', { mktSource });
	}
</script>

{#if showLeadSource}
	<div class={`field ${leadSource.class}`}>
		<label class={leadSource.type} for={leadSource.id}>{leadSource.label}</label
		>
		<select
			class={leadSource.value === '' ? 'clean' : 'dirty'}
			id={leadSource.id}
			bind:value={leadSource.value}
		>
			<option value="" disabled selected>{leadSource.placeholder}</option>
			{#each leadSource.options as option}
				<option value={option.value}>{option.text}</option>
			{/each}
		</select>
	</div>
{/if}
